import Button from '@mui/material/Button'
import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'

export default function PoolCreateButtonMenu(): React.ReactElement {
  const theme = useTheme()

  const navigate = useNavigate()

  return (
    <div>
      <Button
        id="demo-customized-button"
        variant="contained"
        sx={{
          backgroundColor: theme.palette.fg.main,
          color: '#FFFFFF',
          padding: '11px 16px 11px 16px',
          borderRadius: '6px',
        }}
        disableElevation
        onClick={() => navigate('pools/add/v2')}
      >
        Create Vault
      </Button>
    </div>
  )
}
